import React, { useCallback } from 'react'
import styled from 'styled-components/macro'
import { Typography, Button } from '@mui/material'
import loadComponent from 'src/utils/loadMFE'
import { Department } from 'types/orga'
import { useNavigate } from 'react-router-dom'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import GenericNotice from 'src/components/GenericNotice/GenericNotice'
import RouteContainer from 'src/components/App/RouteContainer'

const DepartmentList = React.lazy(() => loadComponent('orga', 'DepartmentList'))

const StyledHeading = styled(Typography)`
    margin-bottom: ${({ theme }) => theme.spacing(1)};
`

export function DepartmentIndexRoute() {
    const navigate = useNavigate()
    const { company, openFlightDeck } = useFlightDeck()

    const onSelect = useCallback(
        (department: Department) => {
            navigate(department._id)
        },
        [navigate],
    )

    return (
        <RouteContainer>
            <StyledHeading variant="h4">Abteilungen</StyledHeading>
            {!company ? (
                <>
                    <GenericNotice
                        title="Keine Firma ausgewählt"
                        message="Abteilungen gehören immer zu einer Firma. Bitte wähle eine Firma im Flight Deck aus, um dessen Abteilungen zu sehen">
                        <Button variant="contained" onClick={openFlightDeck}>
                            Flight Deck öffnen
                        </Button>
                    </GenericNotice>
                </>
            ) : (
                <DepartmentList companyId={company?._id} onSelect={onSelect} />
            )}
        </RouteContainer>
    )
}
